import { render, staticRenderFns } from "./PrescriptionRegistration.vue?vue&type=template&id=373cd14c&scoped=true&"
import script from "./PrescriptionRegistration.vue?vue&type=script&lang=js&"
export * from "./PrescriptionRegistration.vue?vue&type=script&lang=js&"
import style0 from "./PrescriptionRegistration.vue?vue&type=style&index=0&id=373cd14c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373cd14c",
  null
  
)

export default component.exports